module.exports = __webpack_public_path__ + "static/media/3_2.fcf0353e.png";